/**
 * Namespace containing player privacy mode identifiers
 * @namespace PlayerPrivacyModeId
 * @description Defines the available privacy mode settings that control profile visibility
 */
export namespace PlayerPrivacyModeId {
  /**
   * Public privacy mode - profile is fully visible
   * @constant
   * @type {bigint}
   * @description Player profile and information are visible to all users
   */
  export const Public: bigint = 1n;

  /**
   * Private privacy mode - profile is hidden
   * @constant
   * @type {bigint}
   * @description Player profile and information are hidden from other users
   */
  export const Private: bigint = 2n;

  /**
   * Incognito privacy mode - profile shows anonymous info
   * @constant
   * @type {bigint}
   * @description Player profile appears with anonymized/generic information
   */
  export const Incognito: bigint = 3n;
}

/**
 * Type representing valid player privacy mode identifiers
 * @type {PlayerPrivacyModeIdType}
 * @description Union type of all possible privacy mode ID values from PlayerPrivacyModeId namespace
 * @example
 * // Valid values are: 1n, 2n, or 3n
 * const mode: PlayerPrivacyModeIdType = PlayerPrivacyModeId.Public; // 1n
 */
export type PlayerPrivacyModeIdType =
  (typeof PlayerPrivacyModeId)[keyof typeof PlayerPrivacyModeId];
